// extracted by mini-css-extract-plugin
export default {"projectCard":"ProjectCard_projectCard__IcLum"};